import React from 'react';
import ProfileStore from '../../Profile/ProfileStore';
import Icon from '../../Icons/Icon';
import moment from 'moment';
import 'idempotent-babel-polyfill';
moment.locale(window.jenkon.language);

export default class OrderSummary extends React.Component {
    constructor(props) {
        super(props);

        this.state = ProfileStore.getState()

    }

    printScreen() {
        window.print();
    }

    render() {
        let IconData = {
            Fill: '#333',
            name: 'Printer',
            Size: 26
        }

        let isGuestCheckout = readCookie('isGuestCheckout') === "true";
        let customerName = readCookie('customerName');
        if (!this.props.Details.header) return null;


        let Title = !isGuestCheckout && this.props.backToList && typeof this.props.backToList == 'function' ? <div className="blurb text-center no-print"><h2 className="title" tabIndex="0">{this.props.resources["PWS.MyAccount.OrderSummaryTitle"]}: <span>{'#' + this.props.Details.header.orderNumber}</span></h2></div> : null;

        let BackToLink = !isGuestCheckout && this.props.backToList && typeof this.props.backToList == 'function' ? <a href="javascript:void(0);" className="section-back-link details no-print" onClick={this.props.backToList.bind(this)}>&laquo; &nbsp;{this.props.resources["PWS.MyAccount.BackToOrderHistory"]}</a> : null;

        return (
            <div className="site-container icon_button_content animate-in" aria-live="assertive">
                {Title}
                <div className="section-wrapper clearfix">
                    {BackToLink}
                    <div className="dotted-HR"></div>
                    <InvoiceHeader resources={this.props.resources} Header={this.props.Details.header} Consultant={this.state} {...this.props} />
                    <div className="dotted-HR"></div>
                    <div className="invoice-body-wrapper clearfix">
                        <div className="invoice-section-title">{this.props.resources["PWS.MyAccount.OrderSummaryOrderItemsTitle"]}</div>
                        <div className="order-items-wrapper clearfix" aria-live="polite">
                            <div className="column-header product-item clearfix">
                                <div className="product-id">{this.props.resources["PWS.MyAccount.ItemsTableProductIDLabel"]}</div>
                                <div className="product-name">{this.props.resources["PWS.MyAccount.ItemsTableProductNameLabel"]}</div>
                                <div className="product-price">{this.props.resources["PWS.MyAccount.ItemsTablePriceLabel"]}</div>
                                <div className="product-qty">{this.props.resources["PWS.MyAccount.ItemsTableQuantityLabel"]}</div>

                                <div className="product-subtotal">{this.props.resources["PWS.MyAccount.ItemsTableSubTotalLabel"]}</div>
                            </div>
                            <ItemSection resources={this.props.resources} Items={this.props.Details.items} />
                            <OrderTotals resources={this.props.resources} Totals={this.props.Details.totals} />
                            <div className="solid-HR"></div>
                            <div className="table">
                               <div className="row">
                                    <div className="col-sm-12">
                                        <Payments resources={this.props.resources} Payments={this.props.Details.payments} PaymentDate={this.props.Details.header.orderDate} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <Vouchers resources={this.props.resources} Vouchers={this.props.Details.vouchers} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <Shipments resources={this.props.resources} Shipments={this.props.Details.shipments} Items={this.props.Details.items} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <Returns resources={this.props.resources} ReturnList={this.props.Details.returns} />
                                    </div>
                                </div>
                            </div>

                            <div style={{ clear: 'both' }}>&nbsp;</div>
                            <button className="print-button clearfix no-print" onClick={this.printScreen.bind(this)}>
                                <div className="button-icon printer">
                                    <Icon iconData={IconData} />
                                </div>
                                <div className="print-button-text">{window.jenkon.resources["PWS.MyAccount.PrintOrderSummaryButton"]}</div>
                            </button>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

class InvoiceHeader extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        return (
            <div className="invoice-header-wrapper clearfix">
                <div className="invoice-logo">
                    <div className="logo-wrapper"></div>
                </div>
                <div className="invoice-number" tabIndex="0">{this.props.resources["PWS.MyAccount.OrderSummaryOrderNumberTitle"]}
                    <span>&nbsp;{this.props.Header.orderNumber}</span>
                </div>
                <div className="invoice-order-info">
                    <div className="invoice-customer-name" tabIndex="0">
                        {this.props.resources[`${this.props.isEnrollment ? 'PWS.Enrollment.EnrollmentReceiptConsultantLabel' : 'PWS.MyAccount.CustomerLabel'}`]}: <span className="primary-text"><strong>{readCookie('isGuestCheckout') === "true" ? readCookie('customerName') : this.props.Header.customerName}</strong></span>
                    </div>
                    <div className="invoice-customer-id" tabIndex="0">
                        {this.props.resources[`${this.props.isEnrollment ? 'PWS.Enrollment.EnrollmentReceiptConsultantID' : 'PWS.MyAccount.CustomerIDLabel'}`]}: <strong>{this.props.Header.customerId}</strong>
                    </div>
                    <div className="invoice-date" tabIndex="0">
                        {this.props.resources["PWS.MyAccount.InvoiceDateLabel"]}: <strong>{moment(this.props.Header.orderDate).format('LLL')}</strong>
                    </div>
                    <div className="invoice-status" tabIndex="0">
                        {this.props.resources["PWS.MyAccount.InvoiceStatusLabel"]}: <strong>{this.props.resources['PWS.MyAccount.OrderStatus' + this.props.Header.status]}</strong>
                    </div>
                </div>


                {
                    this.props.Header.isParty ? <div className="invoice-party-info">

                        <div className="invoice-partyName" tabIndex="0">
                            {this.props.resources["PWS.MyAccount.PartyNameLabel"]}: <strong>{this.props.Header.partyName}</strong>

                        </div>
                        <div className="invoice-partyCode" tabIndex="0">
                            {this.props.resources["PWS.MyAccount.PartyCodeLabel"]}: <strong>{this.props.Header.partyCode}</strong>

                        </div>
                        <div className="invoice-partyDate" tabIndex="0">
                            {this.props.resources["PWS.MyAccount.PartyDateLabel"]}: <strong>{this.props.Header.partyDate}</strong>

                        </div>
                        <div className="invoice-hostName" tabIndex="0">
                            {this.props.resources["PWS.MyAccount.HostNameLabel"]}: <strong>{this.props.Header.hostName}</strong>
                        </div>
                        <div className="invoice-hostPhone" tabIndex="0">
                            {this.props.resources["PWS.MyAccount.HostPhoneLabel"]}: <strong>{this.props.Header.hostPhone}</strong>

                        </div>

                    </div> : <div />
                }
                <div className="invoice-consultant-info">
                    <div className="invoice-consultant-name" tabIndex="0">
                        {this.props.resources[`${this.props.isEnrollment ? 'PWS.Enrollment.EnrollmentReceiptSponsorLabel' : 'PWS.MyAccount.ConsultantLabel'}`]}: <span className="primary-text"><strong>{this.props.Header.consultantName ? this.props.Header.consultantName : this.props.Consultant.name}</strong></span>
                    </div>

                    <div className="invoice-consultant-phone" tabIndex="0">
                        {this.props.resources["PWS.MyAccount.ConsultantPhoneLabel"]}: <strong>{this.props.Header.consultantPhone ? this.props.Header.consultantPhone : this.props.Consultant.phone}</strong>
                    </div>
                </div>
            </div>
        )
    }
}

class ItemSection extends React.Component {
    constructor(props) {
        super(props);
    }

    createItems(item, i) {
        return <ListItem key={i} Item={item} resources={this.props.resources} />
    }

    render() {
        return (
            <ul className="product-items-wrapper" aria-live="polite">
                {this.props.Items.map(this.createItems.bind(this))}
            </ul>
        )
    }
}

class ListItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showReward: false,
            hasReward: props.rewardDescription != null && props.rewardDescription.length > 0 ? true : false
        }
    }

    showRewards() {
        this.setState({
            showReward: !this.state.showReward
        })
    }

    reward() {
        return (
            <div className="product-item-details clearfix" aria-live="polite">
                <div className="button-icon gift">
                    <Icon iconData={IconData} />
                </div>
                <div className="reward-description">
                    <span className="primary-text" style={{ fontWeight: 'bold' }}>{this.props.Item.rewardDescription}</span>
                </div>
            </div>
        )
    }

    render() {
        let IconData = {
            Fill: '#333',
            name: 'Gift',
            Size: 26
        }

        let rewards = this.state.hasReward ? <span className="product-down-arrow"></span> : null;
        let rewardClick = this.state.hasReward ? this.showRewards.bind(this) : () => { return false };
        let showReward = this.state.showReward ? this.reward() : null;
        return (
            <li>
                <a href="javascript:void(0);" role="button" className="product-item clearfix" onClick={rewardClick}>
                    <div className="product-id">{rewards} {this.props.Item.productCode}</div>
                    <div className="product-name">
                        <span dangerouslySetInnerHTML={{ __html: this.props.Item.productDescription }}></span>
                    </div>
                    <div className="product-price">{this.props.Item.priceEach.displayValue}</div>
                    <div className="product-qty">x {this.props.Item.quantityOrdered}</div>

                    <div className="product-subtotal">{this.props.Item.subtotal.displayValue}</div>
                </a>
                {showReward}
            </li>
        )
    }
}

class OrderTotals extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let freightDiscountDisplayValue = this.props.Totals.freightDiscount.amount != 0
            ? <div className="invoice-totals-price primary-text" tabIndex="0">-{this.props.Totals.freightDiscount.displayValue}</div>
            : '';

        let freightDiscountlabel = this.props.Totals.freightDiscount.amount != 0
            ? <div className="invoice-totals-title">{this.props.resources["PWS.MyAccount.FreightDiscountLabel"]}</div>
            : '';

        let taxLabel = this.props.resources["GLOBAL.OrderTaxWithPercentageLabel.Label"].replace("{0}", this.props.Totals.taxPercentage.displayValue);

        return (
            <div className="invoice-totals clearfix">
                <div className="invoice-totals-prices-wrapper clearfix">
                    <div className="invoice-totals-price" tabIndex="0">{this.props.Totals.subtotal.displayValue}</div>
                    <div className="invoice-totals-price" tabIndex="0">{this.props.Totals.lessVouchers.displayValue}</div>
                    <div className="invoice-totals-price" tabIndex="0">{this.props.Totals.netTotal.displayValue}</div>
                    <div className="invoice-totals-price" tabIndex="0">{this.props.Totals.freight.displayValue}</div>
                    {freightDiscountDisplayValue}
                    <div className="invoice-totals-price" tabIndex="0">{this.props.Totals.tax.displayValue}</div>
                    <div className="invoice-totals-price-total" tabIndex="0">{this.props.Totals.total.displayValue}</div>
                </div>

                <div className="invoice-totals-titles-wrapper clearfix">
                    <div className="invoice-totals-title">{this.props.resources["PWS.MyAccount.SubTotalLabel"]}</div>
                    <div className="invoice-totals-title">{this.props.resources["PWS.MyAccount.LessVouchersLabel"]}</div>
                    <div className="invoice-totals-title">{this.props.resources["PWS.MyAccount.NetTotalLabel"]}</div>
                    <div className="invoice-totals-title">{this.props.resources["PWS.MyAccount.FreightLabel"]}</div>
                    {freightDiscountlabel}
                    <div className="invoice-totals-title">{taxLabel}</div>
                    <div className="invoice-totals-title-total">{this.props.resources["PWS.MyAccount.TotalLabel"]}</div>
                </div>
            </div>
        );
    }
}

class Shipments extends React.Component {
    constructor(props) {
        super(props);
    }

    createIncludedItems(item, i) {
        let productCode = this.props.Items.filter(p => p.code === item.item)
        return (
            <li key={i}>
                <div className="shipped-item clearfix">
                    <div className="tracking-id">
                        {item.trackingUrl != null ? <a href={item.trackingUrl} target="_blank">{item.trackingNumbers}</a> : item.trackingNumbers}
                    </div>
                    <div className="product-id">{productCode.length > 0 ? productCode[0].productCode : null}</div>
                    <div className="product-name">{productCode.length > 0 ? productCode[0].productDescription : null}</div>
                    <div className="product-qty">{item.quantityShipped}</div>
                </div>
            </li>
        )
    }

    createShipmentHeaderInfo(ship) {
        return (
            <div className='clearfix'>
                <div className="clearfix" tabIndex="0">
                    <div><strong tabIndex="0">{this.props.resources["PWS.MyAccount.ShippedToAddressLabel"]}:</strong></div>
                    <div className="address" tabIndex="0">
                        {ship.shipToAddress.addressLine1}, {ship.shipToAddress.addressLine2 != null ? ship.shipToAddress.addressLine2 + ',' : null} {ship.shipToAddress.city} {ship.shipToAddress.stateProvince} {ship.shipToAddress.postalCode}
                    </div>
                </div>
                <div className="clearfix" tabIndex="0">
                    <div><strong tabIndex="0">{this.props.resources["PWS.MyAccount.ShippedToNameLabel"]}:</strong></div>
                    <div className="address" tabIndex="0">
                        {ship.shipToName}
                    </div>
                </div>
                <div className="clearfix" tabIndex="0">
                    <div><strong tabIndex="0">{this.props.resources["PWS.MyAccount.ShippedToPhoneLabel"]}:</strong></div>
                    <div className="address" tabIndex="0">
                        {ship.shipToPhone}
                    </div>
                </div>
                <div className="clearfix" tabIndex="0">
                    <div><strong tabIndex="0">{this.props.resources["PWS.MyAccount.ShippedDeliveryInstructionsLabel"]}:</strong></div>
                    <div className="address" tabIndex="0">
                        {ship.specialDeliveryInstructions} &nbsp;
                    </div>
                </div>
                <div className="clearfix" tabIndex="0">
                    <div><strong>{this.props.resources["PWS.MyAccount.CarrierMethodLabel"]}: </strong></div>
                    <div>
                        <span>{ship.shippingCarrierShippingMethod} {this.props.resources["PWS.Enrollment." + ship.shippingCarrierShippingMethod]}</span><br /><br />
                    </div>
                </div>
                <div className="clearfix" tabIndex="0">
                    <div><span>{ship.deliveryDaysMessage}</span></div>
                </div>
            </div>
        )
    }

    createShipmentHeaderReferenceInfo(ship) {
        return (
            <div className="clearfix">
                <div className="clearfix" tabIndex="0">
                    <div><strong tabIndex="0">{this.props.resources["PWS.MyAccount.ShippedReference"]}:</strong></div>
                    <div className="address" tabIndex="0">
                        {ship.trackingId}
                    </div>
                </div>
                <div className="clearfix" tabIndex="0">
                    <div><strong>{this.props.resources["PWS.MyAccount.ShippedOnLabel"]}: </strong></div>
                    <div tabIndex="0">{moment(ship.shipDate).format('LL')}</div>
                </div>
            </div>
        )
    }

    createShipmentItemTable(ship) {
        let shippedItems = ship.items.filter(s => s.quantityShipped != 0);
        return (
            <div>
                <div className="shipped-items-wrapper clearfix">
                    <div className="shipped-on clearfix">
                        {this.createShipmentHeaderReferenceInfo(ship)}
                    </div>

                    <div className="shipped-to clearfix">
                        <div className="shipped-items-list clearfix">
                            <div className="column-header shipped-item clearfix">
                                <div className="tracking-id">{this.props.resources["PWS.MyAccount.TrackingIDLabel"]}</div>
                                <div className="product-id">{this.props.resources["PWS.MyAccount.OrderSummaryShippedItemCode"]}</div>
                                <div className="product-name">{this.props.resources["PWS.MyAccount.OrderSummaryShippedItemDescription"]}</div>
                                <div className="product-qty">{this.props.resources["PWS.MyAccount.OrderSummaryShippedItemQuantity"]}</div>
                            </div>
                            <ul className="" aria-live="polite">
                                {shippedItems.map(this.createIncludedItems.bind(this))}
                            </ul>
                        </div>
                    </div>
                </div>

                <br />
            </div>
        )
    }

    render() {
        if (this.props.Shipments == null || this.props.Shipments.length == 0) return null;
        return (
            <div>
                <div className="wrapper clearfix">
                    <div className="shipped-on clearfix">
                        <div className="invoice-section-title" tabIndex="0">{this.props.resources["PWS.MyAccount.OrderSummaryShipmentsTitle"]}</div>
                    </div>
                    <div className="shipped-to clearfix">
                        <div className="invoice-section-title" tabIndex="0">{this.props.resources["PWS.MyAccount.OrderSummaryShippedItemsTitle"]}</div>
                    </div>
                </div>

                <div>
                    <div className="wrapper clearfix">
                        <div className="shipped-on clearfix">
                            {this.createShipmentHeaderInfo(this.props.Shipments[0])}
                        </div>
                        <div className="shipped-to clearfix">
                            {this.props.Shipments.map(this.createShipmentItemTable.bind(this))}
                        </div>
                    </div>

                    <div className="spacer12"></div>
                </div>

                <div className="dotted-HR"></div>
                <div className="spacer12"></div>
            </div>
        )
    }
}

//class ShipItem extends React.Component {
//	constructor(props) {
//		super(props);
//	}

//	render() {
//		return (
//			<li>
//				<div className="shipped-item clearfix">
//					<div className="product-id">{this.props.product?.productCode ?? null}</div>
//					<a href="#" target="_blank" className="tracking-id">{this.props.item?.trackingNumbers ?? null}</a>
//				</div>
//			</li>
//			)
//    }
//}

class Payments extends React.Component {
    constructor(props) {
        super(props);
    }

    getPaymentStatusColor(paymentStatus) {
        if (paymentStatus == "Approved") {
            return " payment-status-approved";
        } else if (paymentStatus == "Declined" || paymentStatus == "Error") {
            return " payment-status-declined";
        } else {
            return '';
        }
    }

    createPaymentItems(payment, i) {
        return (
			<div key={i}>
                <div className="shipped-on clearfix" tabIndex="0">
                    <div tabIndex="0"  >{payment.paymentType}</div>
                </div>
                <div className="shipped-on clearfix" tabIndex="0">
                    <div tabIndex="0"  >{payment.amount.displayValue}</div>
                </div>
                <div className="shipped-on clearfix" tabIndex="0">
                    <div className="address" tabIndex="0">{moment(this.props.PaymentDate).format('LL')}</div>
                </div>
                <div className={"payments clearfix" + this.getPaymentStatusColor(payment.paymentStatus)} tabIndex="0">
                    <div tabIndex="0">{this.props.resources["PaymentStatus:" + payment.paymentStatus + ".Description.Text"] || payment.paymentStatusDesc}</div>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.Payments == null || this.props.Payments.length == 0) return null;
        return (
            <div>
                <div className="table">
                    <div className="row">
                        <div className="invoice-section-title" tabIndex="0">{this.props.resources["PWS.MyAccount.PaymentsTitle"]}</div>
                    </div>
                    <div className="row">
                        <div className="col-sm-3" tabIndex="0">
                            <div><strong>{this.props.resources["PWS.MyAccount.PaymentMethodTitle"]} </strong></div>
                        </div>
                        <div className="col-sm-3" tabIndex="0">
                            <div><strong>{this.props.resources["PWS.MyAccount.PaymentAmountTitle"]} </strong></div>
                        </div>
                        <div className="col-sm-3" tabIndex="0">
                            <div><strong>{this.props.resources["PWS.MyAccount.PaymentDateTitle"]}</strong></div>
                        </div>
                    </div>
                    {this.props.Payments.map(this.createPaymentItems.bind(this))}
                  </div>
            </div>
        );
    }
}

class Returns extends React.Component {
    constructor(props) {
        super(props);
    }


    createItems(Return, i) {
        return <ReturnItem key={Return.returnId} Return={Return} resources={this.props.resources} />
    }

    render() {
        if (this.props.ReturnList == null || this.props.ReturnList.length == 0) return false;
        return (
            <div className="invoice-body-wrapper clearfix">
                <div className="invoice-section-title">{this.props.resources["PWS.MyAccount.ReturnTitle"]}</div>
                <div className="invoice-returns">
                    <div className="data-column-header">
                        <div>{this.props.resources["PWS.MyAccount.ReturnIDLabel"]}</div>
                        <div>{this.props.resources["PWS.MyAccount.ReturnDateLabel"]}</div>
                        <div>{this.props.resources["PWS.MyAccount.ReturnActionLabel"]}</div>
                        <div>{this.props.resources["PWS.MyAccount.ReturnProductLabel"]}</div>
                        {/*<div style={{ textAlign: 'right', textTransform: 'uppercase' }}>{this.props.resources["PWS.MyAccount.ItemsTableSubTotalLabel"]}</div> */}
                    </div>
                    {this.props.ReturnList.map(this.createItems.bind(this))}
                </div>
                <div className="spacer12"></div>
                <div className="dotted-HR"></div>
                <div className="spacer12"></div>
            </div>
        )
    }
}

class ReturnItem extends React.Component {
    constructor(props) {
        super(props);
    }

    createProductCodes(code, i) {
        return `${code}${(i + 1) == this.props.Return.productCodes.length ? '' : ','} `;
    }

    render() {

        return (
            <div className="data-row clearfix" aria-live="polite">
                <div className="return-link">{this.props.Return.returnId}</div>
                <div className="return-date">{moment(this.props.Return.date).format('LLL')}</div>
                <div className="return-action">{this.props.Return.action}</div>
                <div className="return-products">{this.props.Return.productCodes.map(this.createProductCodes.bind(this))}</div>
                {/*<div className="return-total" style={{textAlign:'right'}}>{this.props.Return.refundTotal.displayValue}</div>*/}
            </div>
        )

    }
}

class Vouchers extends React.Component {
    constructor(props) {
        super(props);
    }

    createVoucherItems(voucher, i) {
        return (
            <div key={i} className="row">
                <div className="col-sm-3" tabIndex="0">
                    <div tabIndex="0"  >{voucher.voucherCode}</div>
                </div>
                <div className="col-sm-3" tabIndex="0">
                    <div tabIndex="0"  >{voucher.localBalance.displayValue}</div>
                </div>
                <div className="col-sm-3" tabIndex="0">
                    <div tabIndex="0"  >{voucher.localAmount.displayValue}</div>
                </div>
                <div className="col-sm-3" tabIndex="0">
                    <div tabIndex="0"  >{voucher.campaign}</div>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.Vouchers == null || this.props.Vouchers.length == 0) return null;
        return (
            <div>
                <div className="table">
                    <div className="row">
                        <div className="invoice-section-title" tabIndex="0">{this.props.resources["PWS.VouchersTitle.Text"]}</div>
                    </div>
                    <div className="row">
                        <div className="col-sm-3" tabIndex="0">
                            <div><strong>{this.props.resources["PWS.VoucherGrid.VoucherCode"]} </strong></div>
                        </div>
                        <div className="col-sm-3" tabIndex="0">
                            <div><strong>{this.props.resources["PWS.VoucherGrid.Balance"]} </strong></div>
                        </div>
                        <div className="col-sm-3" tabIndex="0">
                            <div><strong>{this.props.resources["PWS.VoucherGrid.Amount"]}</strong></div>
                        </div>
                        <div className="col-sm-3" tabIndex="0">
                            <div><strong>{this.props.resources["PWS.VoucherGrid.Campaign"]}</strong></div>
                        </div>
                    </div>
                    {this.props.Vouchers.map(this.createVoucherItems.bind(this))}
                </div>
            </div>
        );
    }
}

OrderSummary.defaultProps = {
    Details: {}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/OrderHistory/OrderSummary.js